<div class="register-layout " *ngIf="masterAccCreated">
  <div class="row form-layout">
    <div class="col-md-10 form position-relative">
      <div>
        <div class="row">
          <form class="row g-3" [formGroup]="cashAccForm" novalidate>
            <mdb-tabs>
              <mdb-tab title="Cash Account">
                <div class="col-md-6 text-start">
                  <label for="masterAccCashAccCurrency" class="form-label">Currency</label>
                  <div class="d-flex">
                    <select class="form-select" aria-label="Default select example"
                            formControlName="masterAccCashAccCurrency" [ngClass]="{
                        'is-invalid':
                          createCashAccountClicked &&
                          formBankControl['masterAccCashAccCurrency'].errors
                      }">
                      <option [ngValue]="currency.type" *ngFor="let currency of currencyList">
                        {{ currency.type }} - {{ currency.description }}
                      </option>
                    </select>


                    <button style="width: 50px; border-radius: 1000px" type="button" title="Create cash account"
                            class="btn btn-warning btn-floating ml-3" (click)="createCashAccount()">
                      <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>

                      <span *ngIf="!loading"><i class="fas fa-plus"></i></span>
                    </button>


                  </div>
                  <div *ngIf="
                      createCashAccountClicked &&
                      formBankControl['masterAccCashAccCurrency'].errors
                    " class="invalid-feedback">
                    <div *ngIf="
                        formBankControl['masterAccCashAccCurrency'].errors[
                          'required'
                        ]
                      ">
                      Select a Currency
                    </div>
                  </div>
                </div>
                <div>
                  <table *ngIf="cashAccountList.length > 0" class="table align-middle mb-0 bg-white table-lg mt-5"
                         [ngClass]="loading ? 'blur-background' : ''">
                    <thead class="bg-light">
                    <tr>
                      <th>Cash Account No</th>
                      <th>Currency</th>
                    </tr>
                    </thead>
                    <!-- <div *ngIf="loading " class="text-center position-absolute top-50 start-50 " style="z-index: 10000;">
                                      <div class="spinner-border" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                      </div>
                                    </div> -->
                    <tbody *ngFor="let account of cashAccountList">
                    <tr>
                      <td>
                        <p class="fw-normal mb-1">
                          {{ account.accountNumber }}
                        </p>
                      </td>
                      <td>
                        <p class="fw-normal mb-1">{{ account.currency }}</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </mdb-tab>
              <mdb-tab title="Security Account" *ngIf="securityAccLocked">
                <div class="row">
                  <div class="col-md-5">
                    <label for="masterAccSecurityAccType" class="form-label">Cash Account No</label>

                    <select class="form-select" aria-label="Default select example" formControlName="masterAccCashAccId"
                            [ngClass]="{
                        'is-invalid':
                          createSecurityAccountClicked &&
                          formBankControl['masterAccCashAccId'].errors
                      }">
                      <option *ngFor="let item of cashAccountList" [value]="item.accountNumber">{{item.accountNumber}}
                      </option>

                    </select>

                    <div *ngIf="
                        createCashAccountClicked &&
                        formBankControl['masterAccCashAccId'].errors
                      " class="invalid-feedback">
                      <div *ngIf="
                          formBankControl['masterAccCashAccId'].errors[
                            'required'
                          ]
                        ">
                        Select a Cash Account
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <label for="masterAccSecurityAccType" class="form-label">Securty Account Type</label>

                    <select class="form-select" aria-label="Default select example"
                            formControlName="masterAccSecurityAccType" [ngClass]="{
                        'is-invalid':
                          createSecurityAccountClicked &&
                          formBankControl['masterAccSecurityAccType'].errors
                      }">
                      <option value="1">equity</option>
                      <option value="2">options</option>
                    </select>

                    <div *ngIf="
                        createCashAccountClicked &&
                        formBankControl['masterAccSecurityAccType'].errors
                      " class="invalid-feedback">
                      <div *ngIf="
                          formBankControl['masterAccSecurityAccType'].errors[
                            'required'
                          ]
                        ">
                        Select a Securty Account Type
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2 mt-4 text-start">
                    <button style="width: 38px; border-radius: 1000px" type="button" title="Create cash account"
                            class="btn btn-warning btn-floating ml-3" (click)="createSecurityAccount()">
                      <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>

                      <span *ngIf="!loading"><i class="fas fa-plus"></i></span>
                    </button>

                  </div>
                </div>
                <div>
                  <table *ngIf="securityAccountList.length > 0" class="table align-middle mb-0 bg-white table-lg mt-5"
                         [ngClass]="loading ? 'blur-background' : ''">
                    <thead class="bg-light">
                    <tr>
                      <th>Security A/C No</th>
                      <th>Cash A/C No</th>
                      <th>Currency</th>
                    </tr>
                    </thead>
                    <!-- <div *ngIf="loading " class="text-center position-absolute top-50 start-50 " style="z-index: 10000;">
                                        <div class="spinner-border" role="status">
                                          <span class="visually-hidden">Loading...</span>
                                        </div>
                                      </div> -->
                    <tbody *ngFor="let account of securityAccountList">
                    <tr>
                      <td>
                        <p class="fw-normal mb-1">
                          {{ account.accountNumber }}
                        </p>
                      </td>
                      <td>
                        <p class="fw-normal mb-1">
                          {{ account.cashAccId }}
                        </p>
                      </td>
                      <td>
                        <p class="fw-normal mb-1">{{ account.accountType }}</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </mdb-tab>
              <mdb-tab title="Exchange Account" *ngIf="exchangeAccLocked" >

                <div class="row">
                  <div class="col-md-4">
                    <label for="masterAccSecurityAccType" class="form-label">Security Account No</label>

                    <select class="form-select" aria-label="Default select example"
                            formControlName="masterAccSecurityAccId" [ngClass]="{
                          'is-invalid':
                          createExchangeAccClicked &&
                            formBankControl['masterAccSecurityAccId'].errors
                        }">
                      <option *ngFor="let item of securityAccountList" [value]="item.accountNumber">
                        {{item.accountNumber}}</option>

                    </select>

                    <div *ngIf="
                        createExchangeAccClicked &&
                          formBankControl['masterAccSecurityAccId'].errors
                        " class="invalid-feedback">
                      <div *ngIf="
                            formBankControl['masterAccSecurityAccId'].errors[
                              'required'
                            ]
                          ">
                        Select a Cash Account
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label for="masterAccSecurityAccType" class="form-label">Exchange</label>

                    <select (change)="onSelectExchange($event)" class="form-select" aria-label="Default select example"
                            formControlName="masterAccExchangeAccExchange" [ngClass]="{
                          'is-invalid':
                          createExchangeAccClicked &&
                            formBankControl['masterAccExchangeAccExchange'].errors
                        }" >
                      <option *ngFor="let exchange of exchanges" [value]="exchange.exchangeCode">
                        {{exchange.exchangeCode}}</option>

                    </select>

                    <div *ngIf="
                        createExchangeAccClicked &&
                          formBankControl['masterAccExchangeAccExchange'].errors
                        " class="invalid-feedback">
                      <div *ngIf="
                            formBankControl['masterAccExchangeAccExchange'].errors[
                              'required'
                            ]
                          ">
                        Select a Exchange
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label for="masterAccSecurityAccType" class="form-label">Executing Broker</label>

                    <select  class="form-select" aria-label="Default select example"
                             formControlName="masterAccExchangeAccExecBroker" [ngClass]="{
                          'is-invalid':
                          createExchangeAccClicked &&
                            formBankControl['masterAccExchangeAccExecBroker'].errors
                        }">
                      <option *ngFor="let broker of brokers" [value]="broker.executingBrokerId">
                        {{broker.executingBrokerId}}</option>

                    </select>

                    <div *ngIf="
                        createExchangeAccClicked &&
                          formBankControl['masterAccExchangeAccExecBroker'].errors
                        " class="invalid-feedback">
                      <div *ngIf="
                            formBankControl['masterAccExchangeAccExecBroker'].errors[
                              'required'
                            ]
                          ">
                        Select a Executing Broker
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2 mt-4 text-start">
                    <button style="width: 38px; border-radius: 1000px" type="button" title="Create cash account"
                            class="btn btn-warning btn-floating ml-3" (click)="createExchangeAccount()">
                      <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>

                      <span *ngIf="!loading"><i class="fas fa-plus"></i></span>
                    </button>

                  </div>
                </div>
                <div>
                  <table *ngIf="exchangeAccountList.length > 0" class="table align-middle mb-0 bg-white table-lg mt-5"
                         [ngClass]="loading ? 'blur-background' : ''">
                    <thead class="bg-light">
                    <tr>
                      <th>Exchange A/C No</th>
                      <th>Security A/C No</th>
                      <th>Exchange</th>
                    </tr>
                    </thead>
                    <!-- <div *ngIf="loading " class="text-center position-absolute top-50 start-50 " style="z-index: 10000;">
                                          <div class="spinner-border" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                          </div>
                                        </div> -->
                    <tbody *ngFor="let account of exchangeAccountList">
                    <tr>
                      <td>
                        <p class="fw-normal mb-1">
                          {{ account.accountNumber }}
                        </p>
                      </td>
                      <td>
                        <p class="fw-normal mb-1">
                          {{ account.securityAccId }}
                        </p>
                      </td>
                      <td>
                        <p class="fw-normal mb-1">{{ account.exchange }}</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </mdb-tab>
            </mdb-tabs>
          </form>


        </div>
      </div>

    </div>
  </div>
</div>
